import { render, staticRenderFns } from "./PatientHistoryPharmacy.vue?vue&type=template&id=316f34ba&scoped=true"
import script from "./PatientHistoryPharmacy.vue?vue&type=script&lang=js"
export * from "./PatientHistoryPharmacy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316f34ba",
  null
  
)

export default component.exports